module.exports = Studio;


/*****************
 ** WEBPACK FOOTER
 ** external "Studio"
 ** module id = 3
 ** module chunks = 0
 **/